const footerLinks = [
  {
    title: "入口相关",
    items: ["主站入口", "备用线路 A", "镜像地址", "移动端链接"],
  },
  {
    title: "内容分区",
    items: ["娱乐八卦", "网红动态", "品牌商战", "剧集速报"],
  },
  {
    title: "使用帮助",
    items: ["访问说明", "常见问题", "地址通知", "更新日志"],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-50 border-t border-secondary-200/70">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-flashlight-fill text-base"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                黑料平台
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一个专注于入口导航的单页索引，集中整理黑料平台的网址、地址与链接，帮你在找不到首页时快速回到内容页。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md border border-secondary-200 bg-background-50 text-secondary-700">
                <i className="ri-links-line text-base"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md border border-secondary-200 bg-background-50 text-secondary-700">
                <i className="ri-notification-3-line text-base"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md border border-secondary-200 bg-background-50 text-secondary-700">
                <i className="ri-bookmark-line text-base"></i>
              </span>
            </div>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h3 className="text-sm font-bold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.items.map((it) => (
                  <li key={it}>
                    <a
                      href="#entries"
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600 whitespace-nowrap cursor-pointer"
                    >
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-secondary-200/70 pt-6">
          <p className="text-xs text-foreground-500">
            © 2026 黑料平台入口导航 · 本页为静态索引展示，内容仅作访问指引
          </p>
          <p className="text-xs text-foreground-400">
            入口 · 网址 · 地址 · 链接 · 首页访问导航
          </p>
        </div>
      </div>
    </footer>
  );
}